module.exports = __webpack_public_path__ + "static/media/excel-1.a78ba3ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutUs/image/excel-1.jpg
// module id = 434
// module chunks = 0